import { useTranslation } from 'react-i18next';

import { MultiPrimaryAutocompleteField } from '@/components/Form/FormAutocompleteField/MultiPrimaryAutocompleteField';
import type { CommonFieldDef } from '@/core/dcr/fields/types';
import { localSpecialtyRowLabel } from '@/core/dcr/schemas/localSpecialty.schema';

import { useFieldLabel } from '../../_hooks/useFieldLabel';

import { usePicklistFieldOptions } from './PicklistInput';

type Props = {
	name: string;
	def: CommonFieldDef;
};

export const MultiPicklistInput = ({ name, def }: Props) => {
	const { t } = useTranslation();
	const fieldLabel = useFieldLabel();
	const options = usePicklistFieldOptions(def);

	return (
		<MultiPrimaryAutocompleteField
			name={name}
			label={fieldLabel(def)}
			isAutocomplete
			options={options}
			hidePrimaryButton
			oneRequired={def.required}
			canRemoveItems
			max={def.maxItems}
			rowLabel={localSpecialtyRowLabel(t)}
		/>
	);
};
